import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function FlamingoLiteracyLogoDark(props) {
  return (
    <SvgIcon viewBox="0 0 346 125" {...props}>
      <path
        d="M62.2496 121.507L49.5508 122.092V63.0898L47.6382 65.0254V94.284V124.997H65.88L62.2496 121.507Z"
        fill="#CAA965"
      />
      <path d="M52.109 60.4947L47.6381 65.0158L42.2896 59.254L52.109 60.4947Z" fill="#F79979" />
      <path
        d="M42.7052 62.9116L12.3592 57.5372L41.1757 60.8145L42.437 59.4307L9.18505 55.553L8.1189 58.5799L42.4776 64.6216L40.3903 80.2795L44.3374 77.0575L45.187 65.7328L42.7052 62.9116Z"
        fill="#CAA965"
      />
      <path d="M7.42406 47.1226L0 54.4139L21.6769 52.1358L7.42406 47.1226Z" fill="#F79979" />
      <path d="M30.7351 50.0704L15.4869 37.7069L7.42407 47.1226L30.7351 50.0704Z" fill="#F57859" />
      <path d="M30.8413 50.0703L21.6769 52.1357L7.42407 47.1225L30.8413 50.0703Z" fill="#F04338" />
      <path d="M68.1765 37.7069L51.9514 24.2778L54.3799 35.7041L68.1765 37.7069Z" fill="#F79979" />
      <path d="M54.3801 35.7041L51.9515 24.2777L33.79 22.371L54.3801 35.7041Z" fill="#F57859" />
      <path d="M64.5414 50.9914L41.2017 33.7973L68.1767 37.7069L64.5414 50.9914Z" fill="#F57859" />
      <path d="M32.9729 42.7333L40.2635 50.3431L30.7351 50.0703L32.9729 42.7333Z" fill="#F79979" />
      <path d="M41.2014 33.7974L32.9728 42.7333L15.4868 37.7069L41.2014 33.7974Z" fill="#F04338" />
      <path d="M64.5413 50.9914L51.9515 60.5294L30.7351 50.0703L64.5413 50.9914Z" fill="#F04338" />
      <path d="M54.3799 35.7041L33.7899 22.371L19.467 30.8435L54.3799 35.7041Z" fill="#EE3124" />
      <path d="M51.9515 60.5294L27.2544 57.6692L30.735 50.0703L51.9515 60.5294Z" fill="#EE3124" />
      <path d="M32.9729 42.7333L41.2015 33.7973L64.5413 50.9914L32.9729 42.7333Z" fill="#EE3124" />
      <path d="M32.9728 42.7333L30.7349 50.0704L15.4868 37.7069L32.9728 42.7333Z" fill="#EE3124" />
      <path d="M64.5413 50.9914L40.2635 50.3431L32.9729 42.7333L64.5413 50.9914Z" fill="#F57859" />
      <path d="M64.5412 50.9914L51.9514 60.5295L62.5946 58.1068L64.5412 50.9914Z" fill="#C52C23" />
      <path d="M41.2014 33.7973L15.4868 37.7069L19.467 30.8435L41.2014 33.7973Z" fill="#C52C23" />
      <path d="M30.735 50.0704L27.2543 57.6692L21.6768 52.1358L30.735 50.0704Z" fill="#C52C23" />
      <path d="M72.8953 30.4257L76.5049 46.9684L81.6051 29.9498L72.8953 30.4257Z" fill="#F79979" />
      <path d="M78.2075 7.89703L75.6169 1.25111L85.3059 -1.62125e-05L78.2075 7.89703Z" fill="#F57859" />
      <path d="M76.2271 11.9864L81.6051 29.9498L72.8953 30.4257L76.2271 11.9864Z" fill="#F57859" />
      <path d="M76.5049 46.9685L62.5947 58.1068L68.1766 37.7069L76.5049 46.9685Z" fill="#F04338" />
      <path d="M78.2076 7.89706L71.9971 20.7175L70.1772 9.89985L78.2076 7.89706Z" fill="#F04338" />
      <path d="M76.2271 11.9864L72.8953 30.4257L71.9971 20.7175L76.2271 11.9864Z" fill="#C52C23" />
      <path d="M75.6171 1.25113L70.1772 9.89984L78.2076 7.89705L75.6171 1.25113Z" fill="#EE3124" />
      <path d="M72.8951 30.4257L68.1765 37.7069L76.5048 46.9684L72.8951 30.4257Z" fill="#EE3124" />
      <path d="M93.491 13.7253L92.4168 4.10046L85.3059 -6.67572e-06L93.491 13.7253Z" fill="#F04338" />
      <path d="M85.958 15.2837L78.2075 7.89705L85.3059 1.90735e-06L85.8239 11.4611L85.958 15.2837Z" fill="#F04338" />
      <path d="M85.8239 11.4611L93.491 13.7253L85.3059 -6.67572e-06L85.8239 11.4611Z" fill="#FEF2D6" />
      <path d="M95.2351 26.6031L93.4911 13.7253L85.824 11.461L95.2351 26.6031Z" fill="#F0DFAB" />
      <path d="M86.2542 35.5127L91.5577 20.7175L85.824 11.4611L86.2542 35.5127Z" fill="#CAA965" />
      <path d="M95.235 26.6031L86.2542 35.5127L91.5576 20.7175L95.235 26.6031Z" fill="#282A45" />
      <path
        d="M87.2889 7.93627C86.8894 8.33558 86.8894 8.98237 87.2889 9.38187C87.6874 9.78043 88.335 9.78043 88.7337 9.38187C89.1323 8.98237 89.1323 8.33558 88.7337 7.93627C88.335 7.53752 87.6874 7.53752 87.2889 7.93627Z"
        fill="#282A45"
      />
      <path
        d="M114.665 30.6785H134.949V33.1726H117.399V45.016H134.612V47.5087H117.399V62.6611H114.665V30.6785Z"
        fill="#E4E7F5"
      />
      <path d="M141.618 30.6785H144.351V60.1684H159.839V62.6611H141.618V30.6785Z" fill="#E4E7F5" />
      <path
        d="M171.591 52.3038H186.887L179.215 33.3641L171.591 52.3038ZM187.75 54.7978H170.728L167.516 62.6611H164.447L177.537 30.6785H180.941L194.032 62.6611H190.963L187.75 54.7978Z"
        fill="#E4E7F5"
      />
      <path
        d="M225.877 34.2749L214.224 62.6611H213.169L201.469 34.2749V62.6611H198.736V30.6785H202.812L213.696 57.1946L224.534 30.6785H228.657V62.6611H225.877V34.2749Z"
        fill="#E4E7F5"
      />
      <path d="M236.623 30.6785H239.356V62.6611H236.623V30.6785Z" fill="#E4E7F5" />
      <path
        d="M250.051 35.0419V62.6611H247.318V30.6785H250.098L270.141 57.9146V30.6785H272.874V62.6611H270.19L250.051 35.0419Z"
        fill="#E4E7F5"
      />
      <path
        d="M295.848 30.1517C301.124 30.1517 304.959 32.2605 307.884 35.6174L305.823 37.1043C303.569 34.4185 299.924 32.6451 295.848 32.6451C288.32 32.6451 282.518 38.3501 282.518 46.6936C282.518 54.9415 288.32 60.7918 295.848 60.7918C300.115 60.7918 303.472 58.6815 305.247 56.9066V49.235H293.162V46.7895H307.98V57.9625C305.151 61.127 300.883 63.2843 295.848 63.2843C286.881 63.2843 279.642 56.5714 279.642 46.6936C279.642 36.8161 286.881 30.1517 295.848 30.1517Z"
        fill="#E4E7F5"
      />
      <path
        d="M330.234 32.6451C322.467 32.6451 317.576 38.5425 317.576 46.6936C317.576 54.7499 322.467 60.7439 330.234 60.7439C337.905 60.7439 342.894 54.7499 342.894 46.6936C342.894 38.5425 337.905 32.6451 330.234 32.6451ZM330.234 30.1517C339.586 30.1517 345.771 37.3436 345.771 46.6936C345.771 56.0438 339.586 63.2364 330.234 63.2364C320.835 63.2364 314.699 56.0438 314.699 46.6936C314.699 37.3436 320.835 30.1517 330.234 30.1517Z"
        fill="#E4E7F5"
      />
      <path d="M114.673 72.7987H119.468V100.562H133.998V104.781H114.673V72.7987Z" fill="#EE3124" />
      <path d="M139.275 72.7987H144.071V104.781H139.275V72.7987Z" fill="#EE3124" />
      <path d="M159.033 77.0184H149.107V72.7987H173.706V77.0184H163.828V104.781H159.033V77.0184Z" fill="#EE3124" />
      <path
        d="M178.698 72.7987H200.179V77.0184H183.493V86.3684H199.843V90.5889H183.493V100.562H200.179V104.781H178.698V72.7987Z"
        fill="#EE3124"
      />
      <path
        d="M218.068 77.0184H210.012V88.2384H218.068C221.52 88.2384 224.014 85.9861 224.014 82.6284C224.014 79.2723 221.52 77.0184 218.068 77.0184ZM216.006 92.4581H210.012V104.781H205.217V72.7987H218.691C224.781 72.7987 228.954 76.7304 228.954 82.6284C228.954 88.3829 225.068 91.4516 220.994 91.9784L229.193 104.781H223.631L216.006 92.4581Z"
        fill="#EE3124"
      />
      <path
        d="M240.803 93.8971H253.701L247.227 76.9713L240.803 93.8971ZM255.091 98.1639H239.412L236.823 104.781H231.547L244.254 72.7987H250.249L262.954 104.781H257.681L255.091 98.1639Z"
        fill="#EE3124"
      />
      <path
        d="M263.726 88.8139C263.726 78.9842 271.014 72.2719 280.125 72.2719C286.406 72.2719 290.339 75.2927 292.832 79.0321L288.756 81.1902C287.078 78.5053 283.914 76.5388 280.125 76.5388C273.653 76.5388 268.666 81.6219 268.666 88.8139C268.666 95.9587 273.653 101.089 280.125 101.089C283.914 101.089 287.078 99.124 288.756 96.4384L292.832 98.5957C290.29 102.337 286.406 105.357 280.125 105.357C271.014 105.357 263.726 98.6436 263.726 88.8139Z"
        fill="#EE3124"
      />
      <path
        d="M306.935 91.4039L294.42 72.7987H299.936L309.333 87.0884L318.636 72.7987H324.198L311.73 91.4039V104.781H306.935V91.4039Z"
        fill="#EE3124"
      />
    </SvgIcon>
  );
}
